import { render, staticRenderFns } from "./HomeContent1.vue?vue&type=template&id=04bfc8ed&"
import script from "./HomeContent1.vue?vue&type=script&lang=js&"
export * from "./HomeContent1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports